export default __webpack_public_path__ + "static/media/triangle.12e2a5cc.svg";